import { dsl } from '@wix/yoshi-serverless/wrap';

export const searchSuggestionsApi = dsl({
          functionName: 'searchSuggestionsApi',
          fileName: 'api/search/search-suggestions.api',
        });